import { normalizeExtractedDocumentText } from "./text";

const BLOCK_ELEMENTS = new Set([
  "address",
  "article",
  "aside",
  "blockquote",
  "dd",
  "div",
  "dl",
  "dt",
  "figcaption",
  "figure",
  "footer",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hr",
  "li",
  "main",
  "ol",
  "p",
  "pre",
  "section",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "tr",
  "ul",
]);
const OMITTED_ELEMENTS = new Set([
  "canvas",
  "math",
  "nav",
  "noscript",
  "script",
  "style",
  "svg",
  "template",
]);

function appendBoundary(parts: string[]) {
  if (parts.length > 0) parts.push("\n\n");
}

function appendNodeText(node: Node, parts: string[]) {
  if (node.nodeType === Node.TEXT_NODE) {
    parts.push(node.nodeValue || "");
    return;
  }
  if (!(node instanceof Element)) return;

  const tagName = node.localName.toLowerCase();
  if (
    OMITTED_ELEMENTS.has(tagName) ||
    node.hasAttribute("hidden") ||
    node.getAttribute("aria-hidden")?.toLowerCase() === "true"
  ) {
    return;
  }
  if (tagName === "br") {
    parts.push("\n");
    return;
  }

  const block = BLOCK_ELEMENTS.has(tagName);
  if (block) appendBoundary(parts);
  for (const child of node.childNodes) appendNodeText(child, parts);
  if (block) appendBoundary(parts);
}

function cleanSectionLabel(value: string): string {
  return normalizeExtractedDocumentText(value)
    .replace(/\n+/g, " ")
    .slice(0, 80);
}

export function extractTextFromMarkup(markup: string): {
  text: string;
  title: string;
} {
  const document = new DOMParser().parseFromString(markup, "text/html");
  const parts: string[] = [];
  appendNodeText(document.body, parts);
  const heading = document.body.querySelector("h1, h2, h3")?.textContent;
  return {
    text: normalizeExtractedDocumentText(parts.join("")),
    title: cleanSectionLabel(heading || document.title || ""),
  };
}
